// src/index.ts
import { TaskList } from "@tiptap/extension-list";
import { TaskList as TaskList2 } from "@tiptap/extension-list";
var index_default = TaskList;
export {
  TaskList2 as TaskList,
  index_default as default
};
//# sourceMappingURL=index.js.map